import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles(
  (theme) => ({
    navBar: {
      position: "absolute",
      left: 0,
      top: 0,
      zIndex: 1000,

      height: "calc(100vh - 102px)",
      width: 500,
      borderRight: "1px solid #e8e8e8",
      overflow: "hidden",
    },

    navBarMenuWrapper: {
      height: "calc(100vh - 102px)",
    },

    wrapperContent: {
      width: "100%",
      height: "calc(100vh - 102px)",
      overflow: "hidden",
      paddingLeft: 500,
    },

    wrapperContentInner: {},
  }),
  {
    name: "countries-tab-styles",
    flip: null,
  }
);

export default useStyles;
